import { useState, useEffect } from "react";

import ResizeObserver from "resize-observer-polyfill";

const useResizeObserver = (ref: { current?: HTMLElement | null }) => {
  const [dimensions, setDimensions] = useState<DOMRectReadOnly>();

  useEffect(() => {
    const observeTarget = ref?.current;
    const resizeObserver = new ResizeObserver(
      (entries: ResizeObserverEntry[]) => {
        entries.forEach((entry) => {
          setDimensions(entry.contentRect);
        });
      }
    );

    observeTarget && resizeObserver.observe(observeTarget);

    return () => {
      observeTarget && resizeObserver.unobserve(observeTarget);
    };
  }, [ref]);

  return dimensions;
};

export default useResizeObserver;
